// PluroWeb JavaScript
// Form Processing functions
/**************************************************************************************************/

// change input field CSS class on focus
function process_input_focus(objMe)
{
    objFlag = document.getElementById("inputflag_" + objMe.id);
    if ( objFlag != undefined )
    {
        if(!objFlag.origClassName)
            objFlag.origClassName = objFlag.className;
        objFlag.className="inputflag_act";
    }
}

if (typeof console == "undefined") {
    this.console = {log: function() {}};
}

// change input field CSS class on blurr
function process_input_blur(objMe)
{
    objFlag = document.getElementById("inputflag_" + objMe.id);
    if ( objFlag != undefined )
    {
        if(objMe.value.length > 0)
        {
            objFlag.className = 'inputflag_chng';
        }
        else
        {
            if ( (objFlag.origClassName == 'inputflag_err') || (objFlag.origClassName == 'inputflag_req') || (objFlag.origClassName == 'inputflag_ok') )
                objFlag.className = 'inputflag_err';
            else
                objFlag.className = objFlag.origClassName;
        }
    }
}

// Form Country object
function Country(state_label, zip_label)
{
    this.state_label = state_label;
    this.zip_label = zip_label;
}

// populate state drop down depending on the country
function populate_states(country, field, state_label, zip_label, dd_label_prefix)
{
    if (typeof dd_label_prefix == 'undefined')
    {
        dd_label_prefix = 'Select';
    }

    optionList = document.getElementById(field+'_list').options;
    for (i = optionList.length; i >= 0; i--){
        optionList[i] = null;
    }

    if(countries[country])
    {
        document.getElementById(field+'_list').disabled=false;
        if(zip_label != null)
        {
            if(countries[country].zip_label != "" && document.getElementById(zip_label))
                document.getElementById(zip_label).innerHTML  = countries[country].zip_label+":";
            else document.getElementById(zip_label).innerHTML = "Code:";
        }
        else if(document.getElementById(zip_label))
            document.getElementById(zip_label).innerHTML = "Code:";

        if(countries[country].state_label != "")
            document.getElementById(state_label).innerHTML = countries[country].state_label+":";
        else
            document.getElementById(state_label).innerHTML = "Province:";

        optionList[0] = new Option("-- "+dd_label_prefix+' '+countries[country].state_label+" --","");

        for(i=0; i<countries[country].states.length; i++)
        {
            optionList[i+1] = new Option(countries[country].states[i], countries[country].abbrv[i]);
        }

        if(document.getElementById(field+'_list').className != "input_err" && document.getElementById(field+'_list').className != "input_ok") document.getElementById(field+'_list').className = "form-control input_req";
        //show dd
        document.getElementById(field+'_list').style.display = 'block';
        //hide imput
        document.getElementById(field).style.display = 'none';
    }
    else
    {
        document.getElementById(field+'_list').options[0] = country ? new Option("N/A","N/A") : new Option("N/A","");
        document.getElementById(field).value = '';
        //    document.getElementById(field+'_list').disabled=true;
        //hide dd
        //document.getElementById(field+'_list').style.display = 'none';
        //show imput
        //document.getElementById(field).style.display = 'block';

        if(zip_label != null && document.getElementById(zip_label))
            document.getElementById(zip_label).innerHTML = "Zip:";
        else if(document.getElementById(zip_label))
            document.getElementById(zip_label).innerHTML = "Code:";

        document.getElementById(state_label).innerHTML = "Province:";
        document.getElementById(field+'_list').className = "input_opt form-control";
    }
}

//populate hidden input
function populate_state_field(field)
{
    strState = document.getElementById(field+'_list').value;
    if ('N/A' === strState) {
        return;
    }
    document.getElementById(field).value = strState;
}

// select dropdown value
function select_dropdown_value(objDropdownField, strValue)
{
    if ( strValue != '' )
    {
        for(i=0; i<objDropdownField.length; i++)
            if(objDropdownField[i].value == strValue)
                objDropdownField[i].selected = true;
    }
}

// get checked radio button value
function get_checked_radio_value(objRadioButton)
{
    if(!objRadioButton)
        return "";
    var intRadioGroupLength = objRadioButton.length;

    if(intRadioGroupLength == undefined)
        if(objRadioButton.checked)
            return objRadioButton.value;
        else
            return "";
    for(var i = 0; i < intRadioGroupLength; i++)
    {
        if(objRadioButton[i].checked)
            return objRadioButton[i].value;
    }
    return "";
}

// set checked radio button value
function set_checked_radio_value(objRadioButton, strNewValue)
{
    if(!objRadioButton)
        return;

    var intRadioGroupLength = objRadioButton.length;

    if(intRadioGroupLength == undefined)
    {
        objRadioButton.checked = (objRadioButton.value == strNewValue.toString());
        return;
    }

    for(var i = 0; i < intRadioGroupLength; i++)
    {
        objRadioButton[i].checked = false;
        if(objRadioButton[i].value == strNewValue.toString())
            objRadioButton[i].checked = true;
    }
}

function format_decimal(num)
{
    num = num.toString().replace(/\$|\,/g,'');
    if(isNaN(num))
        num = "0";
    sign = (num == (num = Math.abs(num)));
    num = Math.floor(num*100+0.50000000001);
    cents = num%100;
    num = Math.floor(num/100).toString();
    if(cents<10)
        cents = "0" + cents;
    for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
        num = num.substring(0,num.length-(4*i+3))+','+
            num.substring(num.length-(4*i+3));
    return (((sign)?'':'-') + num + '.' + cents);
}

function format_decimal4(num)
{
    num = num.toString().replace(/\$|\,/g,'');
    if(isNaN(num))
        num = "0";
    sign = (num == (num = Math.abs(num)));
    num = Math.floor(num*10000+0.5000000000001);
    cents = num%10000;
    num = Math.floor(num/10000).toString();
    if (cents<10) {
        cents="000"+cents;
    } else if (cents<100) {
        cents="00"+cents;
    } else if(cents<1000) {
        cents = "0" + cents;
    }
    for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++) num = num.substring(0,num.length-(4*i+3))+','+num.substring(num.length-(4*i+3));
    return (((sign)?'':'-') + num + '.' + cents);
}

// Browser Detection functions
/**************************************************************************************************/
function is_in_string(strNeedle, strHaystack)
{
//    alert('test');
    if(strHaystack.indexOf(strNeedle) >= 0)
    {return true;}
    else{return false;}
}

function detect_browser()
{
    var strBrowser;
    strUserAgent = navigator.userAgent.toLowerCase();

    if (is_in_string('konqueror', strUserAgent)) strBrowser = "konqueror";
    else if (is_in_string('safari', strUserAgent)) strBrowser = "safari";
    else if (is_in_string('omniweb', strUserAgent)) strBrowser = "omniweb";
    else if (is_in_string('opera', strUserAgent)) strBrowser = "opera";
    else if (is_in_string('webtv', strUserAgent)) strBrowser = "webtv";
    else if (is_in_string('icab', strUserAgent)) strBrowser = "icab";
    else if (is_in_string('msie', strUserAgent)) strBrowser = "msie";
    else if (!is_in_string('compatible', strUserAgent))    strBrowser = "netscape";
    else strBrowser = "undefined";

//    if (!version) version = detect.charAt(place + thestring.length);
    /*    if (!OS)
        {
            if (checkIt('linux')) OS = "Linux";
            else if (checkIt('x11')) OS = "Unix";
            else if (checkIt('mac')) OS = "Mac"
            else if (checkIt('win')) OS = "Windows"
            else OS = "an unknown operating system";
        }*/

    return strBrowser;
}



// Pop-up and window.open functions
/**************************************************************************************************/
function show_window_content_edit( window_link, title)
{
    var h = Math.ceil(screen.height*0.8);
    var w = Math.ceil(screen.width*0.95);

    var top = window.outerHeight / 2 + window.screenY - (h / 2)
    var left = window.outerWidth / 2 + window.screenX - (w / 2)

    window.open(window_link, title, 'toolbar=no,titlebar=no,width=' + w + ',height=' + h + ',resizable,left=' + left + ',top=' + top);
}

function show_window_centered( window_link, title, w, h )
{
    var top = window.outerHeight / 2 + window.screenY - (h / 2)
    var left = window.outerWidth / 2 + window.screenX - (w / 2)

    window.open(window_link, title, 'toolbar=no,titlebar=no,width=' + w + ',height=' + h + ',resizable,left=' + left + ',top=' + top);
}

function show_window_centered_with_options( link, title, w, h, user_options )
{
    var top = window.outerHeight / 2 + window.screenY - (h / 2)
    var left = window.outerWidth / 2 + window.screenX - (w / 2)

    if ( user_options )
        user_options = ',' + user_options;

    window.open(link, title, 'width=' + w + ',height=' + h + ',resizable,left=' + left + ',top=' + top + user_options);
}

function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

function show_modal_centered(selector, width, height) {
    if(typeof width === 'undefined' || width === null) {
        width = 'auto';
    }

    if(typeof height === 'undefined' || height === null) {
        height = 'auto';
    }

    var body = $('body');
    if(body.length < 1) {
        console.error('Cannot display modal - no body element in DOM!');
        return false;
    }

    var jQSelector = $(selector);
    var jQSelectorLen = jQSelector.length;
    if(jQSelectorLen < 1 || jQSelectorLen > 1) {
        console.error('Cannot display modal - found ' + jQSelectorLen + ' items by selector, expected 1');
        return false;
    }

    var modalId = guid();
    var modalClose = function(e) {
        if(typeof e !== 'undefined') { //May be called from event (this prevents clicking elements below)
            e.preventDefault();
            e.stopPropagation();
        }

        $('#modal-' + modalId).remove();
    };

    jQSelector.hide(0); //Just hide original, do not detach (dialog may be re-displayed)
    jQSelector = jQSelector.clone();

    body.append(
        $('<div/>')
            .attr('id', 'modal-' + modalId)
            .css('background', 'rgba(0,0,0,0.5)')
            .css('width', '100%')
            .css('height', '100%')
            .css('position', 'absolute')
            .css('left', '0')
            .css('top', '0')
            .css('z-index', '100000')
            .click(modalClose)
            .append(
                $('<div/>')
                    .css('background', '#fff')
                    .css('width', width)
                    .css('height', height)
                    .css('position', 'absolute')
                    .css('left', '50%')
                    .css('top', '50%')
                    .css('transform', 'translate(-50%, -50%)')
                    .css('z-index', '200000')
                    .css('padding', '10px')
                    .append(
                        $('<div/>')
                            .text('X')
                            .css('font-family', 'sans-serif')
                            .css('font-weight', 'bolder')
                            .css('cursor', 'pointer')
                            .css('color', '#ff0000')
                            .css('float', 'right')
                            .click(modalClose)
                    )
                    .append(jQSelector)
                    .click(function(e){e.stopPropagation();})
            )
    );

    jQSelector.show(0); //It may be hidden
}

function in_array(strNeedle, arrHaystack)
{
    if ( arrHaystack.length == 0 )
        return false;

    if ( in_array_binary(strNeedle, arrHaystack, 0, arrHaystack.length-1) > -1 )
        return true;
    else
        return false;
}

function in_array_linear(strNeedle, arrHaystack)
{
    for ( i=0; i < arrHaystack.length;  i++ )
        if ( arrHaystack[i].value == strNeedle )
            return true;

    return false;
}

function in_array_binary(strNeedle, arrHaystack, intLeft, intRight)
{
    if ( intRight < intLeft )
        return -1;

    intMiddle = Math.floor((intRight-intLeft)/2) + intLeft;
    if ( arrHaystack[intMiddle].text == strNeedle )
        return intMiddle;

    if ( strNeedle < arrHaystack[intMiddle].text )
        return in_array_binary(strNeedle, arrHaystack, intLeft, intMiddle-1);
    else
        return in_array_binary(strNeedle, arrHaystack, intMiddle+1, intRight);
}

function display_array(arrArray)
{
    var strElements = '';
    for(i=0; i<arrArray.length; i++)
    {
        if ( strElements != '' )
            strElements = strElements + ', ';
        strElements = strElements + arrArray[i].text;
    }

    alert(strElements);
}

function array_search(strNeedle, arrHaystack)
{
    for (i=0; i<arrHaystack.length; i++)
        if ( strNeedle == arrHaystack[i] )
            return i;

    return -1;
}

function toggle_div(objDiv)
{
    if(objDiv.style.display == 'none')
        objDiv.style.display = 'block';
    else objDiv.style.display = 'none';
}

function debug_object(obj, parent)
{
    var msg;
    for (var i in obj)
    {
        if (parent)
        {
            msg = parent + '.' + i + '\n' + obj[i];
        }
        else
        {
            msg = i + '\n' + obj[i];
        }

        if (!confirm(msg)) { return; }
        //document.write(msg);
        if (typeof obj[i] == 'object')
        {
            if (parent) { debug_object(obj[i], parent + '.' + i); } else { debug_object(obj[i], i); }
        }
    }
}

function findPosX(obj)
{
    var curleft = 0;
    if(obj.offsetParent)
        while(1)
        {
            curleft += obj.offsetLeft;
            if(!obj.offsetParent)
                break;
            obj = obj.offsetParent;
        }
    else if(obj.x)
        curleft += obj.x;
    return curleft;
}

function findPosY(obj)
{
    var curtop = 0;
    if(obj.offsetParent)
        while(1)
        {
            curtop += obj.offsetTop;
            if(!obj.offsetParent)
                break;
            obj = obj.offsetParent;
        }
    else if(obj.y)
        curtop += obj.y;
    return curtop;
}


function get_viewport_height()
{
    if (typeof window.innerWidth != 'undefined')
    {
        intHeight = window.innerHeight;
    }
    else if (typeof document.documentElement != 'undefined' && typeof document.documentElement.clientWidth != 'undefined' && document.documentElement.clientWidth != 0)
    {
        intHeight = document.documentElement.clientHeight;
    }
    else
    {
        intHeight = document.getElementsByTagName('body')[0].clientHeight;
    }

    return intHeight;
}


function get_viewport_width()
{
    if (typeof window.innerWidth != 'undefined')
    {
        intWidth = window.innerWidth;
    }
    else if (typeof document.documentElement != 'undefined' && typeof document.documentElement.clientWidth != 'undefined' && document.documentElement.clientWidth != 0)
    {
        intWidth = document.documentElement.clientWidth;
    }
    else
    {
        intWidth = document.getElementsByTagName('body')[0].clientWidth;
    }

    return intWidth;
}

function get_if_from_url()
{
    var strUrl = window.location.href;
    var strUrlId = (strUrl.split("#")[1]);
    if(typeof strUrlId === 'undefined'){ strUrlId =''; }
    return strUrlId;
}

function is_ie()
{
    return (detect_browser() == 'msie');
}


function microtime (get_as_float)
{
    var now = new Date().getTime() / 1000;
    var s = parseInt(now, 10);
    return (get_as_float) ? now : (Math.round((now - s) * 1000) / 1000) + ' ' + s;
}



function htmlspecialchars_decode(str)
{
    return str
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#039;/g, "'");
}


function htmlentities_to_latin(strIn)
{
    var arrChars = Array();

    arrChars["%"] = "&37;";
    arrChars["Œ"] = "&#140;";
    arrChars["‘"] = "&#145;";
    arrChars["’"] = "&#146;";
    arrChars["“"] = "&#147;";
    arrChars["”"] = "&#148;";
    arrChars["•"] = "&#149;";
    arrChars["–"] = "&#150;";
    arrChars["—"] = "&#151;";
    arrChars["˜ "] = "&#152;";
    arrChars["™"] = "&#153;";
    arrChars["š"] = "&#154;";
    arrChars["›"] = "&#155;";
    arrChars["œ"] = "&#156;";
    arrChars["Ÿ"] = "&#159;";
    arrChars["¡"] = "&#161;";
    arrChars["¢"] = "&#162;";
    arrChars["£"] = "&#163;";
    arrChars["¤"] = "&#164;";
    arrChars["¥"] = "&#165;";
    arrChars["¦"] = "&#166;";
    arrChars["§"] = "&#167;";
    arrChars["¨"] = "&#168;";
    arrChars["©"] = "&#169;";
    arrChars["ª"] = "&#170;";
    arrChars["«"] = "&#171;";
    arrChars["¬"] = "&#172;";
    arrChars["­"] = "&#173;";
    arrChars["®"] = "&#174;";
    arrChars["¯"] = "&#175;";
    arrChars["°"] = "&#176;";
    arrChars["±"] = "&#177;";
    arrChars["²"] = "&#178;";
    arrChars["³"] = "&#179;";
    arrChars["´"] = "&#180;";
    arrChars["µ"] = "&#181;";
    arrChars["¶"] = "&#182;";
    arrChars["·"] = "&#183;";
    arrChars["¸"] = "&#184;";
    arrChars["¹"] = "&#185;";
    arrChars["º"] = "&#186;";
    arrChars["»"] = "&#187;";
    arrChars["¼"] = "&#188;";
    arrChars["½"] = "&#189;";
    arrChars["¾"] = "&#190;";
    arrChars["¿"] = "&#191;";
    arrChars["À"] = "&#192;";
    arrChars["Á"] = "&#193;";
    arrChars["Â"] = "&#194;";
    arrChars["Ã"] = "&#195;";
    arrChars["Ä"] = "&#196;";
    arrChars["Å"] = "&#197;";
    arrChars["Æ"] = "&#198;";
    arrChars["Ç"] = "&#199;";
    arrChars["È"] = "&#200;";
    arrChars["É"] = "&#201;";
    arrChars["Ê"] = "&#202;";
    arrChars["Ë"] = "&#203;";
    arrChars["Ì"] = "&#204;";
    arrChars["Í"] = "&#205;";
    arrChars["Î"] = "&#206;";
    arrChars["Ï"] = "&#207;";
    arrChars["Ð"] = "&#208;";
    arrChars["Ñ"] = "&#209;";
    arrChars["Ò"] = "&#210;";
    arrChars["Ó"] = "&#211;";
    arrChars["Ô"] = "&#212;";
    arrChars["Õ"] = "&#213;";
    arrChars["Ö"] = "&#214;";
    arrChars["×"] = "&#215;";
    arrChars["Ø"] = "&#216;";
    arrChars["Ù"] = "&#217;";
    arrChars["Ú"] = "&#218;";
    arrChars["Û"] = "&#219;";
    arrChars["Ü"] = "&#220;";
    arrChars["Ý"] = "&#221;";
    arrChars["Þ"] = "&#222;";
    arrChars["ß"] = "&#223;";
    arrChars["à"] = "&#224;";
    arrChars["á"] = "&#225;";
    arrChars["â"] = "&#226;";
    arrChars["ã"] = "&#227;";
    arrChars["ä"] = "&#228;";
    arrChars["å"] = "&#229;";
    arrChars["æ"] = "&#230;";
    arrChars["ç"] = "&#231;";
    arrChars["è"] = "&#232;";
    arrChars["é"] = "&#233;";
    arrChars["ê"] = "&#234;";
    arrChars["ë"] = "&#235;";
    arrChars["ì"] = "&#236;";
    arrChars["í"] = "&#237;";
    arrChars["î"] = "&#238;";
    arrChars["ï"] = "&#239;";
    arrChars["ð"] = "&#240;";
    arrChars["ñ"] = "&#241;";
    arrChars["ò"] = "&#242;";
    arrChars["ó"] = "&#243;";
    arrChars["ô"] = "&#244;";
    arrChars["õ"] = "&#245;";
    arrChars["ö"] = "&#246;";
    arrChars["ƒ"] = "&#131;";
    arrChars["÷"] = "&#247;";
    arrChars["„"] = "&#132;";
    arrChars["ø"] = "&#248;";
    arrChars["…"] = "&#133;";
    arrChars["ù"] = "&#249;";
    arrChars["†"] = "&#134;";
    arrChars["ú"] = "&#250;";
    arrChars["‡"] = "&#135;";
    arrChars["û"] = "&#251;";
    arrChars["ˆ"] = "&#136;";
    arrChars["ü"] = "&#252;";
    arrChars["‰"] = "&#137;";
    arrChars["ý"] = "&#253;";
    arrChars["Š"] = "&#138;";
    arrChars["þ"] = "&#254;";
    arrChars["‹"] = "&#139;";
    arrChars["ÿ"] = "&#255;";


    for (var strKey in arrChars)
    {
        strIn = strIn.replace(arrChars[strKey], strKey);
    }

    return strIn;
}

function date_dob_field_init(strField)
{
    var strValue = $('.'+strField).val();
    if(strValue != '' && strValue.length > 7)
    {
        //console.log(strValue);
        var strOldY = strValue.substring(0,4);
        var strOldM = strValue.substring(4,6);
        var strOldD = strValue.substring(6,8);

        $('.'+strField+'_year option[value="'+strOldY+'"]').attr('selected', 'selected');
        $('.'+strField+'_month option[value="'+strOldM+'"]').attr('selected', 'selected');
        $('.'+strField+'_day option[value="'+strOldD+'"]').attr('selected', 'selected');

        //console.log(strOldY+'/'+strOldM+'/'+strOldD);
    }
    $('.js_container_'+strField+' select').change(function(){
        var strM = $('.'+strField+'_month').val();
        var strD = $('.'+strField+'_day').val();
        var strY = $('.'+strField+'_year').val();
        var strNewValue = strY+strM+strD+'000000';
        if( strM.length == 2 && strD.length == 2 && strY.length == 4 )
        {
            var strNewValue = strY+strM+strD+'000000';
        }
        else if(strM.length == 2 || strD.length == 2 || strY.length == 4){
            if(strM == '')
                strM = '00';
            if(strY == '')
                strY = '0000';
            if(strD == '')
                strD = '00';
            var strNewValue = strY+strM+strD;
        }
        else
        {
            var strNewValue = '';
        }
        $('.'+strField).val(strNewValue);
    });

}
if(typeof get_cookie != 'function'){
    function get_cookie(c_name)
    {
        var i,x,y,ARRcookies=document.cookie.split(";");
        for (i=0;i<ARRcookies.length;i++)
        {
            x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
            y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
            x=x.replace(/^\s+|\s+$/g,"");
            if (x==c_name)
            {
                return unescape(y);
            }
        }
    }
}
if(typeof set_cookie != 'function'){
    function set_cookie(c_name, c_value, c_exdays)
    {
        var exdate=new Date();
        exdate.setDate(exdate.getDate() + c_exdays);
        var c_value=escape(c_value) + ((c_exdays==null) ? "" : "; expires="+exdate.toUTCString());
        document.cookie=c_name+"="+c_value+"; path=/";
    }
}

function debug(mixData)
{
    console.log(mixData);
}


function init_forgot_password(){

}

if ('function' === typeof $) {
    $(function () {
        try {
            $(".js-forgot-password").popover({
                container: 'body',
                html: true,
                content: function () {
                    return $('.myaccount_forgot_password_main').html();
                }
            });
        } catch(err) {
            // Handle error(s) here
        }
    });
}

